<template>
    <div class='content'>
        <div class="con-1">
            <div  :class="$i18n.locale + '_con-2'">{{ $t('content121') }}</div>
            <div class="con-3">
                {{ $t('content122') }}</div>
            <!-- <div class="btn-box">
                <div class="btn-blue">预约演示</div>
                <div class="btn-we">参观一下</div>
            </div> -->
            <img :src="$i18n.locale == 'zh' ? require('@/assets/xinchou_banner@2x.png'):require('@/assets/en_xinchou_banner@2x.png')" class="com-img" alt="">
        </div>
        <div class="title">{{ $t('content123') }}</div>

        <div  :class="$i18n.locale + '_box-swon'">
            <div  :class="$i18n.locale + '_div-box'">
                <img src="@/assets/bizhong_icon@2x.png" class="con-4-img" alt="">
                <div class="div-title">{{ $t('content124') }}</div>
                <div class="con-5">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content125') }}</div>
                </div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content126') }}</div>
                </div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content127') }}</div>
                </div>
            </div>
            <div :class="$i18n.locale + '_div-box1'">
                <img src="@/assets/daozhang_icon@2x.png" class="con-4-img" alt="">
                <div class="div-title">{{ $t('content128') }}</div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content129') }}</div>
                </div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content130') }}</div>
                </div>

            </div>
            <div :class="$i18n.locale + '_div-box'">
                <img src="@/assets/gongzuoliang_icon@2x.png" class="con-4-img" alt="">
                <div class="div-title">{{ $t('content131') }}</div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content132') }}</div>
                </div>
                <div class="con-6">
                    <img src="@/assets/Slice 31@2x.png" class="con-7" alt="">
                    <div class="text-18">{{ $t('content133') }}</div>
                </div>
            </div>
        </div>

        <div class="box-two">
            <div class="con-9">
                <div class="con-10">
                    <div class="con-11">{{ $t('content134') }}</div>

                    <div class="con-5">
                        <img src="@/assets/Slice 25@2x.png" class="con-11-img" alt="">
                        <div class="con-12">{{ $t('content135') }}</div>
                    </div>
                    <div class="con-13">
                        <img src="@/assets/Slice 25@2x.png" class="con-11-img" alt="">
                        <div class="con-12">{{ $t('content136') }}</div>
                    </div>
                    <div class="con-13">
                        <img src="@/assets/Slice 25@2x.png" class="con-11-img" alt="">
                        <div class="con-12">{{ $t('content137') }}
                        </div>
                    </div>
                    <div class="con-13">
                        <img src="@/assets/Slice 25@2x.png" class="con-11-img" alt="">
                        <div class="con-12">{{ $t('content138') }}</div>
                    </div>
                </div>
                <div class="con-14">
                    <img :src="$i18n.locale == 'zh' ? require('@/assets/Slice 32@2x.png'):require('@/assets/en_Slice 32@2x.png')" class="con-14-img" alt="">
                </div>
            </div>
        </div>

        <div :class="$i18n.locale + '_box-four'">
            <div class="four-text">
                {{ $t('content139') }}
            </div>
            <div :class="$i18n.locale + '_flex-box-174'">
                <div class="con-15">
                    <img src="@/assets/tigong_icon1@2x.png" class="con-15-img" alt="">
                    <div class="con-16">{{ $t('content140') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/tigong_icon2@2x.png" class="con-15-img" alt="">
                    <div class="con-16">{{ $t('content141') }}</div>

                </div>
                <div class="con-15">
                    <img src="@/assets/tigong_icon3@2x.png" class="con-15-img" alt="">
                    <div class="con-16">{{ $t('content142') }}</div>
                </div>
            </div>
            <div class="flex-box-175">
                <div class="con-15">
                    <img src="@/assets/tigong_icon4@2x.png" class="con-15-img" alt="">
                    <div class="con-16">{{ $t('content143') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/tigong_icon5@2x.png" class="con-15-img" alt="">
                    <div class="con-16">{{ $t('content144') }}</div>

                </div>
                <div class="con-15">
                    <img src="@/assets/tigong_icon6@2x.png" class="con-15-img" alt="">
                    <div class="con-16">{{ $t('content145') }}</div>
                </div>
            </div>
        </div>

        <div class="con-17">{{ $t('content146') }}</div>
        <div class="padd-box">
            <div class="padd-box-four">
                <img src="@/assets/jiejue_icon1@2x.png" class="con-17-img" alt="">
                <div class="con-18">{{ $t('content147') }}</div>
            </div>
            <div class="padd-box-four1">
                <img src="@/assets/jiejue_icon2@2x.png" class="con-17-img" alt="">
                <div class="con-18">{{ $t('content148') }}</div>
            </div>
            <div class="padd-box-four2">
                <img src="@/assets/jiejue_icon3@2x.png" class="con-17-img" alt="">
                <div class="con-18">{{ $t('content149') }}</div>
            </div>
            <div class="padd-box-four">
                <img src="@/assets/jiejue_icon4@2x.png" class="con-17-img" alt="">
                <div class="con-18">{{ $t('content150') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
//import

export default {
    name: 'index_2',
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
}
</script>
<style scoped>
.con-1 {
    position: relative;
}

.zh_con-2 {
    font-size: 36px;
    color: #333;
    position: absolute;
    top: 237px;
    left: 360px;
}

.en_con-2 {
    font-size: 36px;
    color: #333;
    position: absolute;
    top: 190px;
    left: 320px;
    width: 584px;
    text-align: center;
}

.con-3 {
    width: 484px;
    font-size: 22px;
    color: #666666;
    position: absolute;
    left: 360px;
    top: 306px;
    line-height: 32px;
}

.btn-box {
    margin-top: 58px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 49px;
    position: absolute;
    top: 375px;
    left: 360px;
}

.con-11-img {
    width: 18px;
    height: 18px;
}

.btn-blue {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #4873FF;
    color: #fff;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;

}

.btn-we {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #fff;
    color: #4873FF;
    cursor: pointer;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    border: 1px solid #4873FF;
    margin-left: 12px;

}

.con-4-img {
    width: 70px;
    height: 70px;
}

.title {
    margin-top: 88px;
    text-align: center;
    color: #333333;
    font-size: 36px;
    font-weight: 600
}

.zh_box-swon {
    padding: 0 360px;
    height: 420px;
    display: flex;
    justify-content: space-between;
    margin-top: 69px;
    margin-bottom: 27px;
}

.en_box-swon {
    padding: 0 360px;
    height: 420px;
    display: flex;
    justify-content: space-between;
    margin-top: 69px;
    margin-bottom: 360px;
}

.con-img {
    width: 100%;
    height: 750px;
}

.zh_div-box {
    width: 371px;
    /* background-color: blue; */
    border-radius: 50px 2px;
    box-shadow: 0 4px 24px 0 #E8EFFA;
    padding: 42px 51px 42px 38px;
    height: 400px;
}

.en_div-box {
    width: 371px;
    /* background-color: blue; */
    border-radius: 50px 2px;
    box-shadow: 0 4px 24px 0 #E8EFFA;
    padding: 42px 51px 42px 38px;
    height: 800px;
}

.con-17 {
    font-size: 36px;
    color: #333333;
    text-align: center;
    margin-top: 145px;
    font-weight: 600;
}

.con-11 {
    font-size: 36px;
    color: #333333;
    margin-bottom: 34px;
    font-weight: 600;

}

.en_div-box1 {
    width: 371px;
    margin: 0 44px;
    border-radius: 50px 2px;
    box-shadow: 0 4px 24px 0 #E8EFFA;
    height: 800px;
    padding: 42px 51px 42px 38px;
}
.zh_div-box1 {
    width: 371px;
    margin: 0 44px;
    border-radius: 50px 2px;
    box-shadow: 0 4px 24px 0 #E8EFFA;
    height: 400px;
    padding: 42px 51px 42px 38px;
}

.con-10 {
    width: 473px;
    height: 875px;
    margin-top: 291px;
}

.div-title {
    color: #333333;
    font-size: 28px;
    line-height: 58px;
    margin: 28px 0 13px 0;

}

.con-18 {
    width: 189px;
    font-size: 22px;
    color: #666666;
    line-height: 32px;
    margin-top: 24px;
}

.con-12 {
    font-size: 20px;
    color: #333333;
    margin-left: 12px;
}

.con-13 {
    display: flex;
    align-items: center;
    margin-top: 11px;
}

.com-img {
    width: 100%;
    height: 100%;
}

.con-15 {
    text-align: center;
}

.con-5 {
    display: flex;
    align-items: center;
}

.text-18 {
    font-size: 22px;
    line-height: 32px;
    color: #666666;
    width: 256px;
}

.con-7 {
    width: 16px;
    height: 16px;
    margin-right: 14px;
}

.con-17-img {
    width: 90px;
    height: 90px;
}

.con-9 {
    height: 875px;
    display: flex;
}

.con-15-img {
    width: 96px;
    height: 96px;
}

.con-14 {
    width: 850px;
    height: 875px;
    margin-top: 15px;
}

.con-14-img {
    width: 100%;
    height: 100%;
}

.con-16 {
    width: 262px;
    font-size: 22px;
    color: #666666;
    line-height: 36px;
}

.box-two {
    padding: 0 226px 0 361px;
    height: 881px;
}

.zh_box-four {
    padding: 106px 356px;
    height: 603px;
    background-color: #F8F9FF;
}

.en_box-four {
    padding: 106px 356px;
    height: 800px;
    background-color: #F8F9FF;
}

.con-6 {
    display: flex;
    align-items: center;
    margin-top: 13px;
}

.four-text {
    color: #333333;
    font-size: 36px;
    text-align: center;
    margin-bottom: 96px;
    font-weight: 600;
}

.zh_flex-box-174 {
    display: flex;
    height: 174px;
    justify-content: space-between;
}

.en_flex-box-174 {
    display: flex;
    height: 280px;
    justify-content: space-between;
}

.flex-box-175 {
    display: flex;
    height: 174px;
    justify-content: space-between;
    margin-top: 91px;
}

.padd-box {
    /* padding: 56px 362px 168px 362px; */
    padding-left: 362px;
    padding-top: 56px;
    padding-bottom: 168px;
    padding-right: 362px;

    display: flex;
    justify-content: space-between;
}

.padd-box-four {
    width: 271px;
    /* height:300px; */
    border-radius: 24px 2px;
    box-shadow: 0 4px 24px 0 #EBEFFA;
    padding: 48px 41px 41px 41px;
    text-align: center;
}

.padd-box-four1 {
    width: 271px;
    /* height:300px; */
    border-radius: 24px 2px;
    box-shadow: 0 4px 24px 0 #EBEFFA;
    padding: 48px 41px 41px 41px;
    text-align: center;
    margin: 0 38px;
}

.padd-box-four2 {
    margin-right: 38px;
    width: 271px;
    /* height:300px; */
    border-radius: 24px 2px;
    box-shadow: 0 4px 24px 0 #EBEFFA;
    padding: 48px 41px 41px 41px;
    text-align: center;
}
</style>